import { theme } from 'Assets/Styles/theme'
import { MessageErrorInput } from 'Components/Message/Error/input'
import TimePicker from 'material-ui/TimePicker'
import React from 'react'

export const TimePickerUnstyled = props => {
  const { className, input, label, placeholder, minutesStep } = props

  return (
    <div className={className}>
      {label && (
        <label className="label" htmlFor={input.name}>
          {label}
        </label>
      )}

      <TimePicker
        id={props.id}
        name={input.name}
        value={input.value || null}
        minutesStep={minutesStep}
        onChange={(evt, newDate) => input.onChange(newDate)}
        placeholder={placeholder}
        textFieldStyle={{
          position: 'relative',
          width: '100%',
          borderRadius: '4px',
          height: '52px',
          background: theme.colors.alabaster,
          border: 'none',
          padding: '0 20px',
          color: theme.colors.secondary,
          outline: 'none',
        }}
      />
      {renderError(props)}
    </div>
  )

  /**
   * Select input has error
   * @returns boolean
   */
  function hasError() {
    return props.meta.touched && props.meta.error
  }

  /**
   * Render field error
   * @returns JSX.Element | null
   */
  function renderError() {
    if (!props.meta) return null
    const inputError = props.meta.error

    return hasError() ? (
      <MessageErrorInput key="errorMessage" message={inputError} />
    ) : null
  }
}



// WEBPACK FOOTER //
// ./src/Components/Form/TimePicker/unstyled.js